import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, pipe } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { HandleError } from '../../utils/handler-error';
import { ResponseData } from '../../utils/response';
import { User } from './user';
import { Util } from '../../utils/util';

@Injectable({ providedIn: 'root' })
export class UserService {

  constructor(private http: HttpClient) { }

  public getUsers(): Observable<ResponseData<User[]>> {
    return this.http.get<ResponseData<User[]>>(`${environment.AUTHENTICATION_API}/user`)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public createUser(user: User): Observable<User> {
    const userForm: FormData = Util.getFormDataImage(user, 'email');
    return this.http.post<User>(`${environment.AUTHENTICATION_API}/user`, userForm)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public deleteUser(user: User): Observable<ResponseData<User>> {
    return this.http.post<ResponseData<User>>(`${environment.AUTHENTICATION_API}/user/delete`, user)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public updateUser(user: User): Observable<ResponseData<User>> {
    const userForm: FormData = Util.getFormDataImage(user, 'name');
    return this.http.put<ResponseData<User>>(`${environment.AUTHENTICATION_API}/user`, userForm)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }
}
